// @flow

import * as React from 'react';

import { Svg } from '@gandi/ui';

import styles from './SwitchIndicator.scss';

type Props = {
  enabled?: boolean,
};

function SwitchIndicator({ enabled }: Props): React.MixedElement {
  return (
    <Svg
      theme={enabled ? 'success' : 'danger'}
      name={enabled ? 'checkmark' : 'cross'}
      className={styles.icon}
    />
  );
}

export default (React.memo<Props>(SwitchIndicator): React.ComponentType<Props>);
